import { styled } from '@/stitches.config';
import { Box } from '@base-app';
import { ReactComponent as ErrorIcon } from '@assets/icons/exit.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/check.svg';
import { ReactComponent as InfoIcon } from '@assets/icons/info.svg';

export const TeamUserStyled = styled(Box, {
  display: 'flex',
  width: '100%',
  backgroundColor: '$coolGray300',
  padding: '$4 $8',
  marginTop: '$4',
  marginBottom: '$4',
  justifyContent: 'flex-start',
  justifyItems: 'flex-start',
  alignItems: 'center',
});

export const TeamUserCellStyled = styled(Box, {
  flexGrow: '2',
  flexBasis: '0',
  textAlign: 'left',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});

export const TeamUserDataCellStyled = styled(TeamUserCellStyled, { fontWeight: '$bold' });

export const TeamUserDataCenteredCellStyled = styled(TeamUserDataCellStyled, { textAlign: 'center' });
export const TeamUserDataRoleCellStyled = styled(TeamUserDataCenteredCellStyled, { flexGrow: '1' });

export const TeamUserActionsCellStyled = styled(TeamUserCellStyled, {
  flexGrow: '2',
  display: 'inline-flex',
  justifyContent: 'flex-end',
  '@sm': {
    flexGrow: '1',
  },
});

export const InfoIconStyled = styled(InfoIcon, { color: '$charcoal500', marginLeft: '$1', width: '$4' });
export const ErrorIconStyled = styled(ErrorIcon, { color: '$error' });
export const SuccessIconStyled = styled(SuccessIcon, { color: '$success' });
